import { render, staticRenderFns } from "./marquee-rivoneed.vue?vue&type=template&id=bd383312&scoped=true&"
import script from "./marquee-rivoneed.vue?vue&type=script&lang=js&"
export * from "./marquee-rivoneed.vue?vue&type=script&lang=js&"
import style0 from "./marquee-rivoneed.vue?vue&type=style&index=0&id=bd383312&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd383312",
  null
  
)

export default component.exports